/**
 * Messages für Kartentausch-Phase
 */

// Kartenanzahl wählen (nur Selector)
export const SELECT_COUNT = [
  "Du bestimmst die Regeln. Wie viele Karten pro Nase?",
  "Du wählst: Wie viele Karten sollen verteilt werden?",
  "Kartenanzahl festlegen. Du hast die Macht!",
];

// Warten auf Kartenanzahl
export const WAIT_COUNT = [
  "Der Boss wählt. Warte ab und sei ruhig.",
  "Kartenanzahl wird gewählt. Geduld.",
  "{name} entscheidet über die Kartenanzahl.",
];

// President gibt Karten
export const PRESIDENT_GIVE = [
  "Zeit, deinen Müll loszuwerden. Gönn dem Arsch was.",
  "Wähl deine schlechtesten Karten. Der Arsch wartet!",
  "Schrott-Zeit! Such dir {count} Karte(n) zum Abschieben.",
  "Du bist oben. Gib {count} Karte(n) nach unten.",
];

// Vice-President gibt Karten
export const VICE_GIVE = [
  "Eine Karte abgeben. Nicht so schlimm wie beim Arsch.",
  "Vize-Pflicht: {count} Karte(n) für den Vize-Loser.",
  "Gib {count} Karte(n) ab. Du bist immerhin Zweiter.",
];

// Arsch gibt Karten (beste)
export const LOSER_GIVE = [
  "Deine besten Karten müssen weg. Das Leben ist unfair.",
  "Tja, Arsch. {count} deiner besten Karten bitte.",
  "Gib dem President deine {count} besten Karten. So sind die Regeln!",
  "Dein Müll ist jetzt sein Gold. {count} Karte(n) rüber!",
];

// Vize-Loser gibt Karten
export const VICE_LOSER_GIVE = [
  "Vize-Arsch gibt eine Karte ab. {count} Stück, bitte.",
  "Deine beste Karte für den Vize. Tut weh, oder?",
  "{count} Karte(n) nach oben. So läuft's.",
];

// Warten auf andere beim Geben (nicht beteiligt)
export const WAIT_GIVE = [
  "Kartentausch läuft. Grab dir Popcorn.",
  "Die anderen tauschen. Entspann dich.",
  "Tausch-Zeit! Du bist nicht beteiligt.",
];

// Loser/Vize-Loser wartet auf Karten zurück (receiving-Phase)
export const LOSER_WAIT = [
  "{name} sucht Karten für dich aus. Gleich kommt Nachschub!",
  "Warte ab... {name} wählt deine neuen Karten.",
  "Deine neuen Karten kommen gleich. {name} entscheidet.",
];

// President empfängt Karten
export const PRESIDENT_RECEIVE = [
  "Neue Karten vom Arsch! Mal sehen, was der Idiot dir geschickt hat.",
  "Hier kommen die Geschenke! {count} Karte(n) vom Loser.",
  "Ah, die besten Karten des Versagers. Lecker!",
];

// Empfängt Karten (generisch)
export const RECEIVE_CARDS = [
  "Neue Karten für dich! {count} Stück.",
  "Tausch abgeschlossen. Schau dir deine neuen Karten an!",
  "Hier sind deine {count} neuen Karten.",
];

// Tausch fertig
export const COMPLETE = [
  "Tausch erledigt. Der Arsch darf anfangen - wie immer.",
  "Kartentausch abgeschlossen! Los geht's.",
  "Fertig getauscht. Neue Runde!",
];

// Citizen (nicht beteiligt)
export const CITIZEN_WAITING = [
  "Du bist Bürger. Kein Tausch für dich. Langweilig, oder?",
  "Als Bürger entspannst du. Andere tauschen.",
  "Bürger-Life: Zusehen und warten.",
];
